import PropTypes from 'prop-types';
import React from 'react'


export default class extends React.Component {
    static propTypes = {
		myProfilePicture: PropTypes.string,
		users: PropTypes.array
	};

    getImage = () => {
		var users = this.props.users;
		if( !users.length ) return this.props.myProfilePicture;
		return users[ users.length - 1 ].profile_picture
	};

    render() {

		return (

			<div className="profile-image" style={{backgroundImage: 'url(' + this.getImage() + ')'}}></div>

		)
	}
}



// WEBPACK FOOTER //
// ./src/js/components/Notifications/components/Item/components/Image.js